import { render, staticRenderFns } from "./k-hero.vue?vue&type=template&id=516e94ff&lang=pug&"
import script from "./k-hero.vue?vue&type=script&lang=js&"
export * from "./k-hero.vue?vue&type=script&lang=js&"
import style0 from "./k-hero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('516e94ff')) {
      api.createRecord('516e94ff', component.options)
    } else {
      api.reload('516e94ff', component.options)
    }
    module.hot.accept("./k-hero.vue?vue&type=template&id=516e94ff&lang=pug&", function () {
      api.rerender('516e94ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/blocks/k-hero/k-hero.vue"
export default component.exports